import { connect } from 'react-redux';
import UserInfo from '../../components/userInfo';

import {
    getUserInfo,
    getUserInfoLoading,
    getAuthentication
} from '../../reducers';

const mapStateToProps = state => ({
    userInfo: getUserInfo(state),
    userLoading: getUserInfoLoading(state),
    authentication: getAuthentication(state)
});

export default connect(mapStateToProps)(UserInfo);



// WEBPACK FOOTER //
// ./src/containers/userInfo/index.js